import { render } from "./view_requests.html?vue&type=template&id=4a427584&external"
import script from "./view_requests.js?vue&type=script&lang=js&external"
export * from "./view_requests.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__